import "./detailedFileAdmin.css";
import downloadImg from "../../../picture/DownloadFile.png";
import Button from "../../../Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";

const DetailedFileAdmin = ({
  file,
  index,
  detailedFile,
  setDetailedFile,
  setFilteringChecked,
  setAddingChecked,
  setAddingDocument,
  location,
}) => {
  const { loggedUser, apiKey, baseUrl } = useGlobalContext();

  const handleActiveFile = (index) => {
    if (detailedFile.find((file) => file === index))
      setDetailedFile(detailedFile.filter((file) => file !== index));
    else setDetailedFile(detailedFile.filter((file) => file !== index));
  };

  const convertBytes = (bytes) => {
    const bytesLength = bytes.toString().length;
    let returnValue;
    if (bytesLength <= 4)
      returnValue = `${Math.round(bytes / Math.pow(1024, 1), 2)}B`;
    else if (bytesLength <= 7)
      returnValue = `${Math.round(bytes / Math.pow(1024, 2), 2)}KB`;
    else if (bytesLength <= 11)
      returnValue = `${Math.round(bytes / Math.pow(1024, 3), 2)}MB`;
    else returnValue = `${Math.round(bytes / Math.pow(1024, 4), 2)}GB`;
    return returnValue;
  };

  const handleAddFile = async () => {
    try {
      axios
        .post(`${baseUrl}/location_documents/getDocumentData.php`, {
          user_id: loggedUser.id,
          location_id: location.location_id,
          api_key: apiKey,
          location_document_id: file.id,
        })
        .then((data) => {
          console.log(data);
          console.log(file);
          const newDocument = {
            uploader: loggedUser.name,
            type: file.extension,
            size: file.size,
            date: new Date(),
            title: file.name,
            text: file.description,
            data: data.data.data,
            fromEditor: false, // bilo u editoru
            intoEditor: false, // trenutno u editoru
          };
          setAddingDocument(newDocument);
          setAddingChecked(true);
          setFilteringChecked(0);
        });
    } catch (error) {
      console.log("Error adding document");
    }
  };

  return (
    <div
      className="detailed-file-admin"
      onClick={() => handleActiveFile(index)}
    >
      <div className="detailed-file-header-admin">
        <span className="detailed-file-number-admin">{index}.</span>
        <span className={"detailed-file-name-admin "}>{file.user_name}</span>
        <span className="detailed-file-time-admin">{file.date}</span>
      </div>
      <div className="detailed-file-middle-admin">
        <span className="detailed-file-title-admin">{file.name}</span>
        <div className="detailed-file-data-admin">
          <span>{convertBytes(file.size ? file.size : 0)}</span>
          <span>.{file.extension}</span>
        </div>
      </div>
      <div className="detailed-file-footer-admin">
        <div className="detailed-file-description-admin">
          {file.description}
        </div>
        <div
          className="detailed-file-btn-admin"
          onClick={() => handleAddFile(file)}
        >
          <Button>
            <img
              className="detailed-file-btn-img-admin"
              src={downloadImg}
              alt=""
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailedFileAdmin;
